import { FC } from 'react';

export enum FeatureModule {
  PLAGIARISM_CHECK = 'plagiarism_check',
  AI_CONTENT_DETECTOR = 'ai_content_detector',
  AI_TEXT_HUMANIZER = 'ai_text_humanizer',
  PARAPHRASE_TEXT = 'paraphrase_text',
}

export enum FeatureKey {
  DETECTOR_DETAILED_REPORT = 'detector_detailed_report',
  DETECTOR_INPUT_HIGHLIGHTS = 'detector_input_highlights',
  DETECTOR_INPUT_LIMIT_OVERFLOW = 'detector_input_limit_overflow',
  PLAGIARISM_DETAILED_REPORT = 'plagiarism_detailed_report',
  PLAGIARISM_INPUT_LIMIT_OVERFLOW = 'plagiarism_input_limit_overflow',
  HUMANIZER_GOAL = 'humanizer_goal',
  PARAPHRASER_LEVEL = 'paraphraser_level',
  PARAPHRASER_TONE_OF_VOICE = 'paraphraser_tone_of_voice',
  PARAPHRASER_OUTPUT_COUNTER = 'paraphraser_output_counter',
}

export type BenefitItemType = {
  key: FeatureKey | null;
  module: FeatureModule | null;
  text: string;
  PreviewComponent?: FC;
};

export type FeatureDenyParams = Record<string, any>;

export type FeatureDefinition = {
  key: FeatureKey;
  onDeny: (params?: FeatureDenyParams) => void | Promise<void>;
};

export type PolicyType = {
  features: {
    [FeatureModule.PLAGIARISM_CHECK]: {
      [FeatureKey.PLAGIARISM_DETAILED_REPORT]: boolean;
      [FeatureKey.PLAGIARISM_INPUT_LIMIT_OVERFLOW]: boolean;
    };
    [FeatureModule.AI_CONTENT_DETECTOR]: {
      [FeatureKey.DETECTOR_INPUT_HIGHLIGHTS]: boolean;
      [FeatureKey.DETECTOR_DETAILED_REPORT]: boolean;
      [FeatureKey.DETECTOR_INPUT_LIMIT_OVERFLOW]: boolean;
    };
    [FeatureModule.AI_TEXT_HUMANIZER]: {
      [FeatureKey.HUMANIZER_GOAL]: boolean;
    };
    [FeatureModule.PARAPHRASE_TEXT]: {
      [FeatureKey.PARAPHRASER_LEVEL]: boolean;
      [FeatureKey.PARAPHRASER_TONE_OF_VOICE]: boolean;
      [FeatureKey.PARAPHRASER_OUTPUT_COUNTER]: boolean;
    };
  };
};
